import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { InvoicesComponent } from './invoices.component';
import { InvoicesFiltersComponent } from './invoices-filters/invoices-filters.component';

import { InvoiceService } from './invoice.service';
import { ListInvoiceService } from './list.service';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    InvoicesFiltersComponent,
    ListInvoiceService,
    InvoiceService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    InvoicesComponent,
    InvoicesFiltersComponent
  ],
  exports: [
    InvoicesComponent
  ]
})
export class InvoicesModule { }
